import { render, staticRenderFns } from "./revoke.vue?vue&type=template&id=04c5edab&scoped=true&"
import script from "./revoke.vue?vue&type=script&lang=js&"
export * from "./revoke.vue?vue&type=script&lang=js&"
import style0 from "./revoke.vue?vue&type=style&index=0&id=04c5edab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5edab",
  null
  
)

export default component.exports